var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useReducer, } from "@wordpress/element";
import { __, sprintf } from "@wordpress/i18n";
import { toast } from "react-toastify";
import { convertCommentFromServer, filterNewComments, } from "../../utils/comment";
import { getUserPageCommentsRequest } from "../api/user-page-api";
import { CHANGE_USER_PAGE_NOTIFICATIONS_LOADING, CHECK_NEW_COMMENTS_INTERVAL, SESSION_EXPIRE_NOTIFICATION_TRESHOLD, SESSION_NOTIFICATION_CHECK_INTERVAL, SET_USER_PAGE_NOTIFICATIONS_NEW_COMMENTS, } from "../constants";
import { useErrorHandler } from "../hooks/useErrorHandler";
import { useLocalStorage } from "../hooks/useLocalStorage";
import { useSession } from "../hooks/useSession";
import { reducer } from "../reducers/user-page-notifications-reducer";
import { UserPageAppContext } from "./UserPageAppContextProvider";
const initialState = {
    newComments: [],
    loading: true,
};
const UserPageNotificationsContext = createContext({
    state: initialState,
    userPageNotificationsDispatch: () => { },
    checkNewComments: () => __awaiter(void 0, void 0, void 0, function* () { }),
});
const UserPageNotificationsContextProvider = ({ children, }) => {
    const [state, userPageNotificationsDispatch] = useReducer(reducer, initialState);
    const { state: { pageHash }, } = useContext(UserPageAppContext);
    const { handleError } = useErrorHandler();
    const { getStoredComments } = useLocalStorage();
    const { isLoggedIn, getSessionTimeLeft } = useSession();
    useEffect(() => {
        const interval = setInterval(() => {
            checkNewComments();
        }, CHECK_NEW_COMMENTS_INTERVAL);
        checkNewComments();
        return () => {
            clearInterval(interval);
        };
    }, []);
    useEffect(() => {
        const interval = setInterval(() => {
            sessionExpireTimeCheck();
        }, SESSION_NOTIFICATION_CHECK_INTERVAL);
        return () => {
            clearInterval(interval);
        };
    }, []);
    const setLoading = (loading) => {
        userPageNotificationsDispatch({
            type: CHANGE_USER_PAGE_NOTIFICATIONS_LOADING,
            payload: loading,
        });
    };
    const sessionExpireTimeCheck = () => {
        if (!isLoggedIn()) {
            return;
        }
        const timeLeft = getSessionTimeLeft(pageHash);
        if (timeLeft && timeLeft <= SESSION_EXPIRE_NOTIFICATION_TRESHOLD) {
            toast.info(sprintf(__("Your session is about to expire in %s minutes", "quicktasker"), timeLeft));
        }
    };
    const checkNewComments = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!isLoggedIn()) {
            return;
        }
        try {
            setLoading(true);
            const storedComments = yield getStoredComments();
            const response = yield getUserPageCommentsRequest(pageHash);
            const comments = response.data.map(convertCommentFromServer);
            const newComments = filterNewComments(comments, storedComments);
            userPageNotificationsDispatch({
                type: SET_USER_PAGE_NOTIFICATIONS_NEW_COMMENTS,
                payload: newComments,
            });
        }
        catch (error) {
            handleError(error);
        }
        finally {
            setLoading(false);
        }
    });
    return (_jsx(UserPageNotificationsContext.Provider, { value: { state, userPageNotificationsDispatch, checkNewComments }, children: children }));
};
export { UserPageNotificationsContext, UserPageNotificationsContextProvider, };
